import ClipLoader from "react-spinners/ClipLoader";

function Loading() {
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <ClipLoader color="#d73636ff" size={60} />
        </div>
    );
}

export default Loading;
